import { LivefireApi, LivefireApiOptions } from '@bblabs/module-library/classes';
import { OutlookLivefireApi } from './OutlookLivefireApi';

/**
 * Default Livefire feed, bypassing connect/disconnect to avoid losing connection
 */
export class ProxyLivefire extends LivefireApi {
  private api: OutlookLivefireApi;
  constructor(api: OutlookLivefireApi, options: LivefireApiOptions) {
    super(options);

    this.api = api;
    this.socket = this.api.socket;
    this.onNewItem = this.onNewItem.bind(this);
  }

  connect() {
    this.api.socket.addEventListener('newItem', this.onNewItem);
  }

  disconnect() {
    this.api.socket.removeEventListener('newItem', this.onNewItem);
  }
}
